import { useEffect } from 'react';

import useDispatch from 'shared/hooks/useDispatch';

import { userSpaceRenovationRequestsApi } from './api';

import PageLayout from 'layouts/PageLayout';
import Stack from '@mui/material/Stack';
import TopBar from './components/TopBar';
import FiltersBar from './components/FiltersBar';
import SpaceRenovationRequestsGrid from './components/SpaceRenovationRequestsGrid';

const UserSpaceRenovationRequests = () => {
  const dispatch = useDispatch();

  const { isLoading, isFetching, isError } =
    userSpaceRenovationRequestsApi.useGetUserSpaceRenovationRequestsListQuery();

  useEffect(() => {
    return () => {
      dispatch(userSpaceRenovationRequestsApi.util.resetApiState());
    };
  }, []);

  return (
    <PageLayout isLoading={isLoading} isError={isError}>
      <Stack spacing={2}>
        <TopBar />
        <Stack>
          <FiltersBar />
          <SpaceRenovationRequestsGrid isFetching={isFetching} />
        </Stack>
      </Stack>
    </PageLayout>
  );
};

export default UserSpaceRenovationRequests;
